import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { getUserResumes } from "../api/api";
// Import the download icon
import { FaDownload } from "react-icons/fa";

function Resumes() {
  const [resumes, setResumes] = useState([]);

  useEffect(() => {
    fetchResumes();
  }, []);

  const fetchResumes = async () => {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (!session) throw new Error("No active session");

      const resumesData = await getUserResumes(session.access_token);
      setResumes(resumesData);
    } catch (error) {
      console.error("Error fetching resumes:", error);
    }
  };

  // Updated to correctly use Singapore time
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Singapore",
    };

    return new Intl.DateTimeFormat("en-SG", options).format(date);
  };

  // Updated ListItem to include the download button
  const ListItem = ({ filename, timestamp, role_applied, download_url }) => {
    console.log(timestamp);
    const handleDownload = async () => {
      try {
        console.log("Attempting to download from:", download_url.signedURL);
        const response = await fetch(download_url.signedURL);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        console.log("Download completed");
      } catch (error) {
        console.error("Error downloading file:", error);
        alert(`Failed to download file: ${error.message}`);
      }
    };

    return (
      <tr className="border-b border-gray-200 hover:bg-gray-100">
        <td className="p-3 text-left text-sm font-medium text-gray-700 whitespace-nowrap">
          {filename}
        </td>
        <td className="p-3 text-right text-sm text-gray-500 whitespace-nowrap">
          {formatDate(timestamp)}
        </td>
        <td className="p-3 text-right text-sm text-gray-500 whitespace-nowrap">
          {role_applied}
        </td>
        <td className="p-3 text-right">
          <button
            onClick={handleDownload}
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-purple-400 rounded-lg hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300"
          >
            <FaDownload className="mr-2" />
            Download
          </button>
        </td>
      </tr>
    );
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-4">Your Resumes</h1>
      <table className="min-w-full bg-white">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">Filename</th>
            <th className="py-2 px-4 border-b">Timestamp</th>
            <th className="py-2 px-4 border-b">Role Applied</th>
            <th className="py-2 px-4 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          {resumes.map((resume, index) => (
            <ListItem
              key={index}
              filename={resume.filename}
              timestamp={formatDate(resume.timestamp)}
              role_applied={resume.role_applied}
              download_url={resume.download_url}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Resumes;
